var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHibernateLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "600px",
    height: "160px",
    viewBox: "0 0 600 160",
    enableBackground: "new 0 0 600 160",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#59666C",
    points: "62.911,68.722 45.366,99.143 45.366,99.143 27.836,68.722 45.373,38.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BCAE79",
    points: "80.458,38.348 45.383,38.348 62.921,68.723 98.005,68.722  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#59666C",
    points: "80.449,99.157 97.993,68.736 97.993,68.736 115.523,99.157 97.986,129.532  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BCAE79",
    points: "62.901,129.529 97.977,129.529 80.438,99.154 45.354,99.157  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#59666C",
    points: "179.113,98.705 179.113,38.702 169.514,38.702 169.514,63.503 141.156,63.503 141.156,38.702  131.468,38.702 131.468,98.705 141.156,98.705 141.156,71.771 169.514,71.771 169.514,98.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#59666C",
    points: "206.918,98.705 206.918,38.702 197.228,38.702 197.228,98.705  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59666C",
    d: "M264.938,80.57c0-6.223-3.644-12.178-11.467-13.688v-0.179c6.134-2.134,10.223-7.556,10.223-13.689 c0-9.245-6.756-14.578-19.823-14.578c-7.289,0-14.134,0.178-18.846,0.267v60.003c6.668,0.089,12.712,0.267,16.356,0.267 C259.783,98.973,264.938,88.395,264.938,80.57L264.938,80.57z M253.56,54.525c0,6.044-4.71,9.689-13.688,9.689 c-2.045,0-3.556,0-5.155-0.089V46.347c2.311-0.089,4.889-0.178,7.556-0.178C250.805,46.169,253.56,49.636,253.56,54.525 L253.56,54.525z M254.716,80.748c0,6.046-4.178,10.312-12.979,10.312c-3.111,0-5.511-0.18-7.021-0.445V71.504 c1.333-0.09,4.443-0.09,5.422-0.09C248.583,71.414,254.716,73.904,254.716,80.748L254.716,80.748z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#59666C",
    points: "310.894,98.705 310.894,90.438 288.938,90.438 288.938,71.771 309.827,71.771 309.827,63.859  288.938,63.859 288.938,46.791 310.894,46.791 310.894,38.702 279.247,38.702 279.247,98.705  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59666C",
    d: "M366.966,98.705l-15.822-20.891c-1.512-1.955-3.377-4.267-5.065-6.4c9.777-1.065,16.979-7.199,16.979-16.8 c0-11.912-8.533-16.268-20.979-16.268c-6.756,0-11.733,0.089-16.089,0.355v60.003h9.688V72.748h0.444l18.668,25.957H366.966 L366.966,98.705z M352.922,55.681c0,5.956-4.711,9.956-12.534,9.956c-2.134,0-3.82-0.089-4.711-0.178V46.436 c1.423-0.089,3.201-0.178,5.066-0.178C348.833,46.258,352.922,49.103,352.922,55.681L352.922,55.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAE79",
    d: "M427.562,98.705V38.702h-9.425V56.48c0,8.801,0.27,21.69,0.624,28.536 c-2.223-4.356-4.622-9.157-7.291-13.603l-19.821-32.712h-12.714v60.003h9.426V78.526c0-8.534-0.179-20.712-0.535-26.579 c1.867,4,4,8.267,6.669,12.622l20.533,34.136H427.562L427.562,98.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAE79",
    d: "M491.638,98.705L469.86,38.702h-10.758l-21.51,60.003h9.777l4.622-13.246h24.268l4.622,13.246H491.638 L491.638,98.705z M473.682,77.726H454.48l6.756-18.578c1.155-3.2,2.134-6.489,2.758-9.512h0.177 c0.711,3.289,1.51,6.134,2.667,9.245L473.682,77.726L473.682,77.726z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BCAE79",
    points: "532.252,46.88 532.252,38.702 489.583,38.702 489.583,46.88 506.029,46.88 506.029,98.705  515.717,98.705 515.717,46.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BCAE79",
    points: "573.922,98.705 573.922,90.438 551.965,90.438 551.965,71.771 572.854,71.771 572.854,63.859  551.965,63.859 551.965,46.791 573.922,46.791 573.922,38.702 542.274,38.702 542.274,98.705  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibernateLogo);
export default __webpack_public_path__ + "static/media/hibernate-logo.6d8d03bc5d087ae547bb7835cdee18b8.svg";
export { ForwardRef as ReactComponent };